// eslint-disable-next-line
export default {
    // Auth
    "auth.login": "Accesso",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.enterEmail": "Inserisci la tua email",
    "auth.enterPassword": "Inserisci la password",
    "auth.loginButton": "Accedi",
    "auth.loggingIn": "Accesso in corso...",
    "auth.loginTitle": "Accesso al sistema",
    "auth.loginDescription": "Inserisci la tua email e password per accedere",
    "auth.logout": "Esci",
    "auth.authError": "Errore di autenticazione",

    // Common
    "common.loading": "Caricamento...",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.delete": "Elimina",
    "common.edit": "Modifica",
    "common.create": "Crea",
    "common.close": "Chiudi",
    "common.confirm": "Conferma",
    "common.yes": "Sì",
    "common.no": "No",
    "common.search": "Cerca",
    "common.filter": "Filtro",
    "common.settings": "Impostazioni",
    "common.active": "Attivo",
    "common.inactive": "Inattivo",
    "common.blocked": "Bloccato",
    "common.total": "Totale",
    "common.deleteUser": "Elimina utente",
    "common.resetPassword": "Reimposta password",
    "common.confirmDelete": "Conferma eliminazione",
    "common.deleteConfirmText": "Sei sicuro di voler eliminare questo utente? Questa azione non può essere annullata.",

    // Roles
    "role.admin": "Amministratore",
    "role.teacher": "Insegnante",
    "role.student": "Studente",

    // Navigation
    "nav.dashboard": "Pannello di controllo",
    "nav.users": "Utenti",
    "nav.students": "Studenti",
    "nav.teachers": "Insegnanti",
    "nav.courses": "Corsi",
    "nav.schedule": "Orario",
    "nav.grades": "Voti",
    "nav.last_entry": "Ultimo accesso",
    "nav.visits": "Visite",
    "nav.never": "Mai",

    // Admin Dashboard
    "admin.title": "Pannello amministratore",
    "admin.createTeacher": "Crea insegnante",
    "admin.systemUsers": "Utenti del sistema",
    "admin.userManagement": "Gestione di tutti gli utenti del sistema",
    "admin.stats.admins": "Amministratori",
    "admin.stats.teachers": "Insegnanti",
    "admin.stats.students": "Studenti",
    "admin.block": "Blocca",
    "admin.unblock": "Sblocca",

    // Teacher Dashboard
    "teacher.title": "Pannello insegnante",
    "teacher.inviteStudent": "Invita studente",
    "teacher.myStudents": "I miei studenti",
    "teacher.studentManagement": "Gestione degli studenti nei tuoi gruppi",
    "teacher.noStudents": "Non hai ancora studenti",
    "teacher.inviteFirst": "Invita il primo studente cliccando il pulsante sopra",
    "teacher.addedOn": "Aggiunto il:",

    // Student Dashboard
    "student.title": "Area personale dello studente",
    "student.personalInfo": "Informazioni personali",
    "student.yourData": "I tuoi dati nel sistema",
    "student.fullName": "Nome completo",
    "student.role": "Ruolo",
    "student.status": "Stato",
    "student.courses": "Corsi",
    "student.coursesDesc": "I miei corsi e materiali",
    "student.schedule": "Orario",
    "student.scheduleDesc": "Orario delle lezioni",
    "student.grades": "Voti",
    "student.gradesDesc": "I miei voti e risultati",
    "student.notifications": "Notifiche",
    "student.updates": "Ultimi aggiornamenti e annunci",
    "student.welcome": "Benvenuto nel sistema!",
    "student.welcomeDesc": "Ti sei registrato con successo nel sistema di gestione della scuola. Qui potrai visualizzare i tuoi corsi, l'orario e i voti.",
    "student.today": "Oggi",
    "student.featuresInDev": "Funzionalità in sviluppo",
    "student.featuresDesc": "Funzionalità aggiuntive per gli studenti (corsi, compiti, voti) saranno aggiunte nelle prossime versioni del sistema.",
    "student.info": "Informazioni",

    // Password Change
    "password.change": "Cambio password",
    "password.new": "Nuova password",
    "password.confirm": "Conferma password",
    "password.required": "È necessario cambiare la password temporanea per continuare",
    "password.enter": "Inserisci una nuova password per il tuo account",
    "password.minLength": "Minimo 6 caratteri",
    "password.repeat": "Ripeti la nuova password",
    "password.saving": "Salvataggio in corso...",
    "password.success": "Password cambiata con successo",
    "password.error": "Errore nel cambio della password",
    "password.minError": "La password deve contenere almeno 6 caratteri",
    "password.mismatch": "Le password non coincidono",

    // Create Teacher Modal
    "createTeacher.title": "Crea insegnante",
    "createTeacher.description": "Inserisci i dati del nuovo insegnante. Un invito sarà inviato all'email specificata.",
    "createTeacher.fullName": "Nome completo",
    "createTeacher.fullNamePlaceholder": "Mario Rossi",
    "createTeacher.emailPlaceholder": "insegnante@scuola.it",
    "createTeacher.creating": "Creazione in corso...",
    "createTeacher.success": "Insegnante creato con successo",
    "createTeacher.error": "Errore nella creazione dell'insegnante",
    "createTeacher.exists": "Un utente con questa email esiste già",

    // Invite Student Modal
    "inviteStudent.title": "Invita studente",
    "inviteStudent.description": "Inserisci i dati del nuovo studente. Un invito sarà inviato all'email specificata.",
    "inviteStudent.fullName": "Nome completo",
    "inviteStudent.fullNamePlaceholder": "Paolo Bianchi",
    "inviteStudent.emailPlaceholder": "studente@scuola.it",
    "inviteStudent.sending": "Invio dell'invito in corso...",
    "inviteStudent.success": "Studente invitato con successo",
    "inviteStudent.error": "Errore nell'invito dello studente",

    // System
    "system.title": "Sistema di formazione a distanza",
    "system.error": "Errore di sistema",
    "system.networkError": "Errore di rete",
    "system.unauthorized": "Accesso non autorizzato",
    "system.forbidden": "Accesso negato",
    "system.notFound": "Non trovato",
    // Trainers
    "messages.userDeleted": "Utente eliminato con successo",
    "messages.passwordReset": "Password reimpostata e inviata via email",
    "messages.deleteError": "Errore durante l'eliminazione dell'utente",
    "messages.resetError": "Errore durante il reset della password",

    "training.start": "Inizia allenamento",
    "trainings.title": "Moduli di allenamento",
    "trainings.memory": "Allenamento della memoria",
    "trainings.memory.description": "Esercizi per allenare la memoria degli studenti",
    "trainings.logic": "Problemi di logica",
    "trainings.logic.description": "Problemi di logica e puzzle per studenti",
    "trainings.back": "Indietro",
    "trainig.notImplemented": "Questo modulo di allenamento non è ancora stato implementato",
    // Mental arithmetics
    "trainings.mental": "Aritmetica mentale",
    "trainings.mental.description": "Allenamento di aritmetica mentale per studenti",
    "mentalArithmetic": "Aritmetica mentale",
    "trainer": "Allenatore",
    "flashCards": "Flash card",
    "additionSubtraction": "Addizione / Sottrazione",
    "multiplicationDivision": "Moltiplicazione / Divisione",
    "selectTrainerSettings": "Seleziona le impostazioni dell'allenatore",
    "selectCardsSettings": "Seleziona le impostazioni delle flash card",
    "selectMultiSettings": "Seleziona le impostazioni dell'allenatore",
    "go": "Via",
    "theme": "Tema",
    "difficulty": "Difficoltà",
    "digits": "Cifre",
    "actionsCount": "Numero di azioni",
    "inputTime": "Tempo per la risposta",
    "speed": "Velocità",
    "start": "Inizia",
    "stop": "Stop",
    "settings": "Impostazioni",
    "continue": "Continua",
    "simple": "Semplice",
    "brother": "Fratello",
    "friend": "Amico",
    "friendBrother": "Amico + Fratello",
    "transitions": "Transizioni",
    "allThemes": "Tutti i temi",
    "multiplication": "Moltiplicazione",
    "division": "Divisione",
    "squaring": "Elevamento al quadrato",
    "performExercise": "Esegui l'esercizio",
    "yourAnswer": "La tua risposta:",
    "correct": "Corretto",
    "incorrect": "Sbagliato",
    "answer": "Risposta",
    "sec": "sec",
    "multiplier": "Moltiplicatore",
    "divisor": "Divisore",
    "any": "Qualsiasi",
    "multiplicationTable": "Tavola pitagorica",
    "byMultiplicationTable": "Secondo la tavola pitagorica",
    "resetAllSettings": "Reimpostare tutte le impostazioni e ricaricare la pagina?",
    "difficulties": {
        "0-4": "0-4",
        "0-5": "0-5",
        "0-6": "0-6",
        "0-7": "0-7",
        "0-8": "0-8",
        "0-9": "0-9",
        "4": "4",
        "3": "3",
        "2": "2",
        "1": "1",
        "9": "9",
        "8": "8",
        "7": "7",
        "6": "6",
        "5": "5",
        "50Plus": "50 +",
        "50Minus": "50 -",
        "100Plus": "100 +",
        "100Minus": "100 -"
    },
    "multiDifficulties": {
        "multiplicationTable": "Tavola pitagorica",
        "2x1": "II x I",
        "3x1": "III x I",
        "2x2": "II x II",
        "4x1": "IIII x I",
        "3x2": "III x II",
        "base50": "Base 50",
        "base100": "Base 100",
        "base200": "Base 200",
        "byMultiplicationTable": "Secondo la tavola pitagorica",
        "2div1": "II / I",
        "3div1": "III / I",
        "4div1": "IIII / I",
        "2div2": "II / II",
        "3div2": "III / II",
        "4div2": "IIII / II",
        "4div3": "IIII / III",
        "2-10": "2-10",
        "on5": "per 5",
        "11-19": "11-19",
        "20-30": "20-30",
        "30-70": "30-70",
        "80-120": "80-120"
    },
    "multiThemes": {
        "multiplication": "Moltiplicazione",
        "division": "Divisione",
        "squaring": "Elevamento al quadrato"
    },
    "cardsDifficulties": {
        "0-4": "0-4",
        "0-9": "0-9"
    }
}